/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

type ISetup = {[key: string]: any};

export const getElementSetup = (sessionId: number | string): Promise<IResponse<ISetup>> => {
    const param = {
        parent_id: sessionId,
        parent_type: 4,
    }
    return fetchData(Api.GET_ELEMENT_SETUP, param).then((res: IResponse<ISetup>) => {
        return res.data;
    });
};
